import { render, staticRenderFns } from "./KListItemAction.vue?vue&type=template&id=7bcb02b3"
import script from "./KListItemAction.vue?vue&type=script&lang=js"
export * from "./KListItemAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemAction } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemAction})
